<div [formGroup]="form" class="d-flex align-items-center justify-content-between dvance-option-wrapper">
    <mat-label class="mat-label-general me-19 advance-option-lable">
        <!-- Advance Options -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.ADVANCE_OPTIONS' | transloco }}
    </mat-label>
    <mat-checkbox class="checkbox-wrap" name="advance_option" formControlName="enableAdvOp"></mat-checkbox>
</div>
